module.exports = __webpack_public_path__ + "static/media/3zero.41e95b35.png";